<template>
  <ui-dialog
    :title="$t('message.permissions.permissionsGranted')"
    :closable="false"
    :show="show"
    @input="close"
    custom-class="permissions-granted-dialog"
  >
    <PreviewData show-type show-email show-count show-permissions vertical />
    <SectionLoader :status="loading" :opacity="1" />
    <template #actions>
      <ui-button
        color="primary"
        @click="close"
        :disabled="loading"
        class="confirm-btn"
      >
        {{ $t("message.common.ok") }}
      </ui-button>
    </template>
  </ui-dialog>
</template>

<script>
import { companyMember } from "@/helpers/mixins/company-member";
import PreviewData from "@/components/Permissions/PreviewData";
import serviceHandler from "../../helpers/handlers/service";
import { CompanyService } from "@/services/permissions";
import SectionLoader from "@/components/Loader/SectionLoader";

export default {
  name: "PermissionsGrantedDialog",
  mixins: [companyMember],
  components: {
    PreviewData,
    SectionLoader
  },
  model: {
    prop: "show",
    event: "input"
  },
  props: {
    show: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false
    };
  },
  created() {
    this.saveMember();
  },
  methods: {
    async saveMember() {
      this.loading = true;

      const { email, ...body } = await this.$store.dispatch(
        "permissions/getMemberRequestBody"
      );
      const result = await serviceHandler(
        this.member.id
          ? CompanyService.updateMember(this.member.id, body, this.company.id)
          : CompanyService.saveMember({ email, ...body }, this.company.id)
      );

      if (result) {
        this.$store.commit("permissions/SET_MEMBER", result);
      } else {
        this.close();
      }

      this.loading = false;
    },
    close() {
      this.$emit("confirmed");
      this.closeDialog();
    }
  }
};
</script>

<style lang="scss">
.permissions-granted-dialog {
  .confirm-btn {
    width: 130px;
    margin-left: auto;
    margin-right: auto;
  }

  .data-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: $spacing 0;
  }

  .label,
  .value {
    font-weight: 500;
    @include font-size(14px);
    line-height: 17px;
    color: $text;
  }

  .label {
    opacity: 0.4;
    margin-right: $spacing;
  }
}
</style>
